module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst parts = []\nconst fieldConfig = model.config || {}\nconst startAttribute = fieldConfig.startAttribute || 'startTS'\nconst endAttribute = fieldConfig.endAttribute || 'endTS'\nconst startTS = attributes[startAttribute]\nconst endTS = attributes[endAttribute]\nconst start = startTS && utils.moment(startTS).format('DD.MM.YYYY') || false\nconst end = endTS && utils.moment(endTS).format('DD.MM.YYYY') || false\nif(start){\nparts.push(start)\n}\nif(end && start !== end){\nparts.push('-')\nparts.push(end)\n}\nif(parts.length < 1){\nparts.push('-')\n}\n%><div><%\n%><%- parts.join(fieldConfig.delimiter || '<br>') %><%\n%></div>"
  , __filename = "components/templates/core/table/fields/timeRange.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const parts = []
const fieldConfig = model.config || {}
const startAttribute = fieldConfig.startAttribute || 'startTS'
const endAttribute = fieldConfig.endAttribute || 'endTS'
const startTS = attributes[startAttribute]
const endTS = attributes[endAttribute]
const start = startTS && utils.moment(startTS).format('DD.MM.YYYY') || false
const end = endTS && utils.moment(endTS).format('DD.MM.YYYY') || false
if(start){
parts.push(start)
}
if(end && start !== end){
parts.push('-')
parts.push(end)
}
if(parts.length < 1){
parts.push('-')
}

    ; __line = 22
    ; __append("<div>")
    ; 

    ; __line = 23
    ; __append( parts.join(fieldConfig.delimiter || '<br>') )
    ; 

    ; __line = 24
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/table/fields/timeRange.ejs

}